export enum Locales {
  EN = 'en',
  RU = 'ru',
}

export interface LanguageType {
  value: string
  label: string
  icon?: string
}

export const LANGUAGES: LanguageType[] = [
  {
    value: Locales.EN,
    label: 'English',
    icon: 'circle-flags:us',
  },
  {
    value: Locales.RU,
    label: 'Русский',
    icon: 'circle-flags:ru',
  },
]
